import * as React from 'react';

export function IconCheck() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fill="#0468ff"
        /* eslint-disable */
        d="M7.234 20c-.62 0-1.21-.277-1.616-.762L.512 13.13a2.22 2.22 0 01.231-3.077 2.09 2.09 0 013 .237l3.339 3.993 10.55-13.045c1.633-2.346 3.343-1.047 1.702 1.309L8.965 19.087a2.115 2.115 0 01-1.73.913z"
      />
    </svg>
  );
}
